import { Property, PropertyValue } from 'api/clients/PropertyClient'
import { AlmanacFile } from 'types'

export type ClearPropertyEventDetails = {
  anchorFile: AlmanacFile
  anchorProperty: Property<PropertyValue> | 'Name'
}
export type ClearPropertyEvent = CustomEvent<ClearPropertyEventDetails>
export const clearPropertyEventName = 'clearProperty'
